import React, { useState } from "react";
import successTick from "../../assets/successTick.svg";
import CommonModal from "./CommonModal";
import { Typography } from "@mui/material";
import "./messagepopup.scss";
import closeIcon from "../../assets/close-icon.svg";

const MessagePopup = ({ messagePopup, setMessagePopup, text }) => {
  const [loaded, setLoaded] = useState(false);
  const load = () => {
    setLoaded(true);
  };
  return (
    <CommonModal
      open={messagePopup}
      onClose={() => setMessagePopup(false)}
      className="message-success"
    >
      <div className="message-success-main-wrapper">
        <div className="message-main-box">
          <div className="message-header">
            <img
              src={closeIcon}
              alt="close"
              onClick={() => setMessagePopup(false)}
            />
          </div>
          <div className="message-info-wrap">
            <img
              src={successTick}
              className="success-tick"
              alt="success-tick"
              onLoad={load}
            />
            {loaded && (
              <Typography className="success-message">{text}</Typography>
            )}
          </div>
        </div>
      </div>
    </CommonModal>
  );
};

export default MessagePopup;
